import * as z from 'zod';
import { isoDateSchema, isoDateTimeSchema, companyContactId, workInProgressStatementId, fileId } from '../../types/opaque.mjs';
import { currencySchema, wipStatementFileSchema } from '../../types/utils.mjs';

const workInProgressStatementSchema = z.object({
    date: isoDateSchema,
    projectBacklogCost: currencySchema.optional(),
    projectBacklogGrossProfit: currencySchema.optional(),
});
var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.object({
            id: workInProgressStatementId,
            date: isoDateSchema,
            companyContactId: companyContactId,
            projectBacklogCost: currencySchema.nullish(),
            projectBacklogGrossProfit: currencySchema.nullish(),
            files: z.array(wipStatementFileSchema),
            underwriterLock: z.boolean(),
            createdAt: isoDateTimeSchema,
            updatedAt: isoDateTimeSchema,
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var List;
(function (List) {
    (function (Response) {
        Response.schema = z.array(Get.Response.schema);
    })(List.Response || (List.Response = {}));
})(List || (List = {}));
var Create;
(function (Create) {
    (function (Request) {
        Request.schema = z.object({
            date: isoDateSchema,
            companyContactId: companyContactId,
            projectBacklogCost: currencySchema.optional(),
            projectBacklogGrossProfit: currencySchema.optional(),
            fileIds: z.array(fileId).optional(),
        });
    })(Create.Request || (Create.Request = {}));
})(Create || (Create = {}));
var Update;
(function (Update) {
    (function (Request) {
        Request.schema = z.object({
            projectBacklogCost: currencySchema.optional(),
            projectBacklogGrossProfit: currencySchema.optional(),
            fileIds: z.array(fileId).optional(),
        });
    })(Update.Request || (Update.Request = {}));
})(Update || (Update = {}));

export { Create, Get, List, Update, workInProgressStatementSchema };
